"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nanoid = _interopRequireDefault(require("nanoid"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _heading = _interopRequireDefault(require("@paprika/heading"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _TriggerButton = _interopRequireDefault(require("./components/TriggerButton"));

var types = _interopRequireWildcard(require("./types"));

var _Confirmation = require("./Confirmation.styles");

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "Confirmation___StyledDiv",
  componentId: "sc-1x5322x-0"
})(["", ""], _Confirmation.confirmStyles);

var _StyledDiv2 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "Confirmation___StyledDiv2",
  componentId: "sc-1x5322x-1"
})(["", ""], _Confirmation.confirmBodyStyles);

var _StyledDiv3 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "Confirmation___StyledDiv3",
  componentId: "sc-1x5322x-2"
})(["", ""], _Confirmation.confirmFooterStyles);

var Confirmation = function Confirmation(props) {
  var body = props.body,
      buttonSize = props.buttonSize,
      children = props.children,
      confirmButtonType = props.confirmButtonType,
      confirmLabel = props.confirmLabel,
      defaultIsOpen = props.defaultIsOpen,
      heading = props.heading,
      isPending = props.isPending,
      onClose = props.onClose,
      onConfirm = props.onConfirm,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["body", "buttonSize", "children", "confirmButtonType", "confirmLabel", "defaultIsOpen", "heading", "isPending", "onClose", "onConfirm"]);

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isConfirmOpen = _React$useState2[0],
      setIsConfirmOpen = _React$useState2[1];

  var confirmButtonRef = _react["default"].useRef(null);

  var triggerRef = _react["default"].useRef(null);

  var titleId = _react["default"].useRef((0, _nanoid["default"])()).current;

  var descriptionId = _react["default"].useRef((0, _nanoid["default"])()).current;

  var I18n = (0, _useI18n["default"])();
  var popoverOffset = 4;
  var popoverKey = (0, _nanoid["default"])();

  var focusConfirmButton = function focusConfirmButton() {
    if (confirmButtonRef.current) confirmButtonRef.current.focus();
  };

  var handleOpenConfirm = function handleOpenConfirm() {
    setIsConfirmOpen(true);
    setTimeout(focusConfirmButton, 250);
  };

  _react["default"].useEffect(function () {
    if (defaultIsOpen && !isConfirmOpen) {
      handleOpenConfirm();
    }
  }, [confirmButtonRef, defaultIsOpen]);

  _react["default"].useEffect(function () {
    popoverKey = (0, _nanoid["default"])();
  }, [isPending]);

  _react["default"].useEffect(function () {
    if (isConfirmOpen === false) {
      if (triggerRef.current) triggerRef.current.focus();
      setTimeout(onClose, 250);
    }
  }, [isConfirmOpen]);

  var handleCloseConfirm = function handleCloseConfirm() {
    setIsConfirmOpen(false);
  };

  var handleOnConfirm = function handleOnConfirm() {
    onConfirm(handleCloseConfirm);
  };

  var renderTrigger = function renderTrigger() {
    // wrapping the returned item in a function to avoid wrapping children in
    // a RawButton and needing to tab twice
    // https://github.com/acl-services/paprika/issues/126
    return function () {
      return /*#__PURE__*/_react["default"].cloneElement(children, {
        isConfirmOpen: isConfirmOpen,
        onOpenConfirm: handleOpenConfirm,
        triggerRef: triggerRef
      });
    };
  };

  var popoverContent = /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_popover["default"].Card, {
    role: "dialog",
    "aria-labelledby": heading ? titleId : null,
    "aria-describedby": body ? descriptionId : null
  }, /*#__PURE__*/_react["default"].createElement(_StyledDiv, null, heading && /*#__PURE__*/_react["default"].createElement(_heading["default"], {
    id: titleId,
    displayLevel: 5,
    level: 2
  }, heading), body && /*#__PURE__*/_react["default"].createElement(_StyledDiv2, {
    id: descriptionId
  }, body), /*#__PURE__*/_react["default"].createElement(_StyledDiv3, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    canPropagate: false,
    "data-pka-anchor": "confirmation.confirm-button",
    isPending: isPending,
    isSemantic: false,
    kind: confirmButtonType,
    onClick: handleOnConfirm,
    ref: confirmButtonRef,
    size: buttonSize
  }, confirmLabel), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    canPropagate: false,
    "data-pka-anchor": "confirmation.cancel-button",
    isDisabled: isPending,
    isSemantic: false,
    kind: types.MINOR,
    onClick: handleCloseConfirm,
    size: buttonSize
  }, I18n.t("actions.cancel"))))));

  return /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({
    "data-pka-anchor": "confirmation",
    isOpen: isConfirmOpen,
    key: popoverKey,
    offset: popoverOffset,
    onClose: handleCloseConfirm
  }, moreProps), children && /*#__PURE__*/_react["default"].createElement(_popover["default"].Trigger, null, renderTrigger()), popoverContent);
};

Confirmation.types = {
  size: constants.defaultSize,
  kind: constants.kind
};
var propTypes = {
  /** Content of the popover confirmation */
  body: _propTypes["default"].node,

  /** Size of the button */
  buttonSize: _propTypes["default"].oneOf([Confirmation.types.size.SMALL, Confirmation.types.size.MEDIUM, Confirmation.types.size.LARGE]),
  children: _propTypes["default"].node,

  /** Determine the styling of the confirm button */
  confirmButtonType: _propTypes["default"].oneOf([Confirmation.types.kind.PRIMARY, Confirmation.types.kind.DESTRUCTIVE]),

  /** Label for the confirm button  */
  confirmLabel: _propTypes["default"].string.isRequired,

  /** If the popover is open by default */
  defaultIsOpen: _propTypes["default"].bool,

  /** Heading for the popover confirmation */
  heading: _propTypes["default"].string,

  /** If the confirm button should render in a pending state (with a spinner icon) */
  isPending: _propTypes["default"].bool,

  /** Callback when cancel button is clicked */
  onClose: _propTypes["default"].func,

  /** Callback when confirm button is clicked */
  onConfirm: _propTypes["default"].func.isRequired
};
var defaultProps = {
  body: null,
  buttonSize: Confirmation.types.size.MEDIUM,
  children: null,
  confirmButtonType: Confirmation.types.kind.DESTRUCTIVE,
  defaultIsOpen: false,
  heading: null,
  isPending: false,
  onClose: function onClose() {}
};
Confirmation.displayName = "Confirmation";
Confirmation.propTypes = propTypes;
Confirmation.defaultProps = defaultProps;
Confirmation.TriggerButton = _TriggerButton["default"];
var _default = Confirmation;
exports["default"] = _default;
//# sourceMappingURL=Confirmation.js.map